/* eslint-disable react/jsx-no-useless-fragment */
import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import useLocalStorage from '../../hooks/useLocalStorage';
import { getCookie } from '../../hooks/useCookie';
import { formatSpeed } from './Broadband.util';
// import { NOT_ELLIGIBLE } from '../shared/Constants';

const BroadbandAfterPrequalTitle = props => {
  const theme = useTheme();
  const localStore = useLocalStorage();
  const { getLocalStorage } = localStore;
  const [maxSpeed, setMaxSpeed] = useState('');

  useEffect(() => {
    if (JSON.parse(getLocalStorage('PREQUAL_RESULT'))?.services.length !== 0)
      setMaxSpeed(props.maxSpeed);
  }, [props.maxSpeed]);
  return (
    <>
      {!props.holdPrequal && (
        <>
          {(props.isMBBJourney ||
            (!props.isMBBJourney && getCookie('MYEIR_BB_ADDED') === 'true') ||
            (!props.isMBBJourney && props.COEligibilityStatus === 'ECC' && props.ECCText) ||
            (!props.isMBBJourney && props.COEligibilityStatus === 'ECC' && !props.ECCText)) && (
            <Typography
              component='h1'
              variant='h1'
              sx={styles(theme).afterPrequalBannerText}
              color={theme.palette.secondary.mobileActiveToggleBackground}
            >
              {props.isMBBJourney &&
                (props.MBBTitleAfterPrequal
                  ? props.MBBTitleAfterPrequal
                  : 'No limits 5G Broadband is the best broadband available')}
              {!props.isMBBJourney &&
                getCookie('MYEIR_BB_ADDED') === 'true' &&
                'Would you like to add eir TV to your bundle?'}
              {!props.isMBBJourney &&
                props.COEligibilityStatus === 'ECC' &&
                (props.ECCText
                  ? props.ECCText
                  : 'You are in contract with your broadband but can upgrade your package to add TV or mobile')}
            </Typography>
          )}
          {!props.isMBBJourney &&
            !props.isR6NGB &&
            (props.COEligibilityStatus === '' || props.COEligibilityStatus === 'E') &&
            getCookie('MYEIR_BB_ADDED') !== 'true' && (
              <Typography
                component='h1'
                variant='h1'
                sx={styles(theme).afterPrequalBannerText}
                color={theme.palette.secondary.mobileActiveToggleBackground}
                dangerouslySetInnerHTML={{
                  __html: `${props.titleAfterPrequalFirstHalf}
                  ${formatSpeed(maxSpeed)}
          ${props.titleAfterPrequalSecondHalf}`,
                }}
              />
            )}
          {props.isR6NGB &&
            (props.COEligibilityStatus === '' || props.COEligibilityStatus === 'E') &&
            getCookie('MYEIR_BB_ADDED') !== 'true' && (
              <Typography
                component='h1'
                variant='h1'
                sx={styles(theme).afterPrequalBannerText}
                color={theme.palette.secondary.mobileActiveToggleBackground}
                dangerouslySetInnerHTML={{
                  __html: `${props.r6NGBTitleAfterPrequalFirstHalf}
                  ${formatSpeed(maxSpeed)}
          ${props.r6NGBTitleAfterPrequalSecondHalf}`,
                }}
              />
            )}
        </>
      )}
      {props.holdPrequal && !props.isMBBJourney && getCookie('MYEIR_BB_ADDED') === 'true' && (
        <Typography
          component='h1'
          variant='h1'
          sx={styles(theme).afterPrequalBannerText}
          color={theme.palette.secondary.mobileActiveToggleBackground}
        >
          {!props.isMBBJourney &&
            getCookie('MYEIR_BB_ADDED') === 'true' &&
            'Would you like to add eir TV to your bundle?'}
        </Typography>
      )}
    </>
  );
};

export default BroadbandAfterPrequalTitle;
